import React, { useEffect, useRef, useState } from "react";
import ICImage from "../../../core-component/ui/ICImage";
import { useNavigate } from "react-router-dom";
import { routePublic } from "../../../routes/PublicRoutePath";
import {
  ICButton,
  ICConfirmationModal,
  ICModal,
} from "../../../core-component/ui";
import UseTranslationHook from "../../../hooks/UseTranslationHook";
import ChangePassword from "../../../screens/change-password/ChangePassword";
import {
  changePasswordIcon,
  signOutIcon,
} from "../../../assets/icons/SvgIconList";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const profileRef = useRef<HTMLDivElement | null>(null);
  const { t } = UseTranslationHook();
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

  useEffect(() => {
    const handleProfileOutsideClick = (event: Event) => {
      if (
        isProfileDropdownOpen &&
        profileRef.current &&
        !profileRef.current.contains(event.target as Node)
      ) {
        setIsProfileDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleProfileOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleProfileOutsideClick);
    };
  }, [isProfileDropdownOpen]);

  const handleModalClose = (value: boolean) => {
    if (value) {
      navigate("/" + routePublic.login);
      localStorage.clear();
    }
    setShowSignOutModal(false);
  };

  const handelLogout = () => {
    setShowSignOutModal(true);
  };

  return (
    <header className="flex items-center justify-end w-full p-4 bg-subtle h-16 border-b border-base">
      <div className="flex items-center">
        <div className="relative flex items-center">
          <div className="relative">
            <div className="flex relative" ref={profileRef}>
              <button
                onClick={() => {
                  setIsProfileDropdownOpen((prev) => !prev);
                }}
                className="relative flex items-center justify-center cursor-pointer rounded-full text-sm focus:outline-none"
              >
                <ICImage
                  className="size-10 rounded-full"
                  src="https://randomuser.me/api/portraits/men/3.jpg"
                />
                <span className="bottom-0 left-7 absolute  w-3 h-3 bg-success-emphasis border-2 border-subtle rounded-full"></span>
              </button>

              {isProfileDropdownOpen && (
                <div className="relative z-30">
                  <div className="absolute z-10 right-0 top-10 w-52 text-sm font-normal bg-subtle border  rounded-md shadow-sm divide-y">
                    <div className="p-2">
                      <div className="p-2 hover:bg-base rounded-md text-sm flex cursor-pointer">
                        <div className="relative">
                          <ICImage
                            className="size-10 rounded-full"
                            src="https://randomuser.me/api/portraits/men/3.jpg"
                          />
                          <span className="bottom-0 left-7 absolute  w-3 h-3 bg-success-emphasis border-2 border-subtle rounded-full"></span>
                        </div>
                        <div className="ps-3 items-center">
                          <div>Dp Infosoft</div>
                          <p className=" text-muted ">{t("admin")}</p>
                        </div>
                      </div>
                    </div>
                    <div className="p-2">
                      <ICButton
                        onClick={() => {
                          setShowChangePasswordModal(true);
                          setIsProfileDropdownOpen(false);
                        }}
                        className="p-2 inline-flex items-center text-default bg-subtle text-sm hover:bg-base rounded-md cursor-pointer w-full"
                      >
                        <div className="size-5 inline-flex mr-2">
                          {changePasswordIcon}
                        </div>
                        {t("change_password")}
                      </ICButton>
                    </div>
                    <div className="p-2">
                      <ICButton
                        className="justify-center font-medium inline-flex items-center bg-danger-emphasis"
                        onClick={() => {
                          handelLogout();
                          setIsProfileDropdownOpen(false);
                        }}
                      >
                        {t("logout")}
                        <div className="rtl:rotate-180 size-5 ms-2">
                          {signOutIcon}
                        </div>
                      </ICButton>
                    </div>
                  </div>
                  <div
                    id="my-element"
                    className={
                      "absolute  z-10 right-4 top-11 w-5 h-5 bg-skin-profile transform rotate-45 origin-bottom top-arrow-border"
                    }
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showSignOutModal && (
        <ICConfirmationModal
          title={t("log_out")}
          message={t("log_out_message")}
          onClose={(value) => handleModalClose(value)}
        />
      )}
      {showChangePasswordModal && (
        <ICModal
          title={t("change_password")}
          onClose={() => {
            setShowChangePasswordModal(false);
          }}
        >
          <div>{<ChangePassword />}</div>
        </ICModal>
      )}
    </header>
  );
};

export default Header;
